import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, vShow as _vShow, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-53832a46"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "all_camera_list_wrap" }

import CameraItem from './CameraItem'
import CameraItemDetail from './CameraItemDetail'
import { Camera } from '@/@types/typescript-axios/api'
import { ref, withDefaults } from 'vue'

type PropsType = {
  cameraListData: Camera[]
  cameraDetailShow?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CameraItemPane',
  props: {
    cameraListData: null,
    cameraDetailShow: { type: Boolean, default: false }
  },
  emits: ["showDetailPage", "setCameraLocation"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'showDetailPage', value: boolean): void
  (e: 'setCameraLocation', lat: number, lon: number): void
}), expose: any, slots: any, attrs: any }) {

const cameraData = ref({})





const showDetailPage = (detailCameraData: Camera) => {
  cameraData.value = detailCameraData
  emit('setCameraLocation', detailCameraData.location_latitude, detailCameraData.location_longitude)
  emit('showDetailPage', true)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.cameraListData, (camera, index) => {
      return _withDirectives((_openBlock(), _createBlock(_unref(CameraItem), {
        onShowDetailPage: showDetailPage,
        "camera-data": camera,
        key: index
      }, null, 8, ["camera-data"])), [
        [_vShow, !__props.cameraDetailShow]
      ])
    }), 128)),
    (__props.cameraDetailShow)
      ? (_openBlock(), _createBlock(_unref(CameraItemDetail), {
          key: 0,
          "camera-data": cameraData.value
        }, null, 8, ["camera-data"]))
      : _createCommentVNode("", true)
  ]))
}
}

})